import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'and',
    standalone: false
})
export class AndPipe implements PipeTransform {
    public transform(value: boolean, other: boolean): boolean {
        return value && other;
    }
}
